import { SOCIETY_SLABS } from "@/data/site";

const inr = (n) => `₹${n.toLocaleString("en-IN")}`;

// Published, verifiable society rent slab matrix.
export const SlabMatrix = () => {
  const { cols, rows, electricity, totalMin, totalMax } = SOCIETY_SLABS;
  // max rent cell = last row, last col
  const maxRow = rows.length - 1;
  const maxCol = cols.length - 1;

  return (
    <div data-testid="slab-matrix">
      <div className="overflow-x-auto rounded-xl border border-ink/10 bg-white">
        <table className="w-full min-w-[560px] text-sm">
          <thead>
            <tr className="bg-ink text-white">
              <th className="p-4 md:p-5 text-left font-mono text-xs uppercase tracking-[0.16em] font-500">
                Rent / screen / mo
              </th>
              {cols.map((c) => (
                <th key={c} className="p-4 md:p-5 text-center font-mono text-xs uppercase tracking-[0.14em] font-500 text-white/80">
                  {c}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, ri) => (
              <tr key={row.label} className={`border-t border-ink/10 ${ri % 2 ? "bg-paper/60" : "bg-white"}`}>
                <td className="p-4 md:p-5 font-display font-700">{row.label}</td>
                {row.values.map((v, ci) => {
                  const highlight = false;
                  return (
                    <td key={ci} className="p-3 md:p-4 text-center">
                      <span
                        data-testid={`slab-${ri}-${ci}`}
                        className={`inline-block min-w-[64px] rounded-md px-3 py-2 font-display font-700 ${
                          highlight ? "bg-teal text-ink" : "text-ink"
                        }`}
                      >
                        {inr(v)}
                      </span>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="rounded-lg border border-ink/10 bg-white p-5">
          <p className="font-mono text-xs uppercase tracking-[0.16em] text-ink/50">Electricity</p>
          <p className="mt-2 font-display font-800 text-2xl">+ {inr(electricity)}</p>
          <p className="mt-1 text-sm text-ink/55">per screen, all slabs - covered by AdX</p>
        </div>
        <div className="rounded-lg border border-ink/10 bg-white p-5">
          <p className="font-mono text-xs uppercase tracking-[0.16em] text-ink/50">Indicative range</p>
          <p className="mt-2 font-display font-800 text-2xl">{inr(totalMin)} – {inr(totalMax)}</p>
          <p className="mt-1 text-sm text-ink/55">per screen, per month</p>
        </div>
        <div className="rounded-lg bg-ink text-white p-5">
          <p className="font-mono text-xs uppercase tracking-[0.16em] text-teal">Higher tiers</p>
          <p className="mt-2 font-display font-800 text-2xl">up to {inr(totalMax)}</p>
          <p className="mt-1 text-sm text-white/55">Larger, higher-occupancy communities</p>
        </div>
      </div>
      <p className="mt-5 font-mono text-xs uppercase tracking-[0.14em] text-ink/45">
        {SOCIETY_SLABS.note} Indicative figures - final terms are confirmed per community.
      </p>
    </div>
  );
};
